const CHILD_RELATION_NAMES = ['長男', '長女', '次男', '次女', '三男', '三女']
const CHILD_RELATION_REPORT_TYPES = ['child', 'real_child_or_adopted_child']

export const isChild = (relationName: string | undefined, relationReportType: string | undefined) => {
  return (
    CHILD_RELATION_NAMES.includes(relationName || '') || CHILD_RELATION_REPORT_TYPES.includes(relationReportType || '')
  )
}
